import TAGGED from "../modules/tagged_content"

const [ w, d, content ] = [ window, document, 'service' ]

const init = () => {
  
  w.load['header'].done(() => {
    let path = location.pathname
    switch( parseInt( w.query_string('article') ) ){
      case 1:
        $('header .p-gnav').currentMenu({ url: `${path}?mode=detail&article=1` })
        break;
      default:
        $('header .p-gnav').currentMenu({ url: `${path}`})
    }
  })

}

const detail_init = async post_id => {
  $('.mainImg').remove()
  let articles = await $.getArticles({ content })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == post_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // ページングボタン名
  let opt ={
        prev:'Prev',
        next:'Next',
        list:'List'
      };
  let $pagination = $( '.paginationbox .pageNav>a[href]' )

  $pagination.each(function(){
    let id = this.href.match(/article=([\d]+)/)[1],
        item = articles.filter(function(o,i){
          if(o.id==id) return true;
        }).shift();
    let html = `<span>${item.title}</span>`
    if( this.classList.contains('prev') ) opt.prev = html
    if( this.classList.contains('next') ) opt.next = html
  });
  $.pagingText(opt)
}


export default function SERVICE () {
  TAGGED()
  $(() => {
    init()
    if( w.query_string('article') ) detail_init( w.query_string('article') )
  })
}